import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ccifData {
  otpResponseData: any[]; 
}

const initialState: ccifData = {
  otpResponseData: [],
};

const ccifDataSlice = createSlice({
  name: 'ccifData',
  initialState,
  reducers: {
    setccifData: (state, action: PayloadAction<any[]>) => {
      state.otpResponseData = action.payload;
    },
  },
});

export const { setccifData } = ccifDataSlice.actions;
export default ccifDataSlice.reducer;